var _path, _rect, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddUsersL(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 19V19.5H7H21H21.5V19V17.25C21.5 16.4845 21.1126 15.8509 20.5739 15.3538C20.0386 14.8598 19.3215 14.4673 18.562 14.163C17.0438 13.5549 15.2306 13.25 14 13.25C12.7694 13.25 10.9562 13.5549 9.43797 14.163C8.67847 14.4673 7.96136 14.8598 7.4261 15.3538C6.88745 15.8509 6.5 16.4845 6.5 17.25V19ZM14 12.5C16.2099 12.5 18 10.7099 18 8.5C18 6.29011 16.2099 4.5 14 4.5C11.7901 4.5 10 6.29011 10 8.5C10 10.7099 11.7901 12.5 14 12.5Z",
    stroke: "#7F82A2"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 6,
    width: 5,
    height: 1,
    transform: "rotate(90 5 6)",
    fill: "#7F82A2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 9,
    width: 5,
    height: 1,
    transform: "rotate(-180 7 9)",
    fill: "#7F82A2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddUsersL);
export default __webpack_public_path__ + "static/media/Add_users-l.011bcbd63f80f53da45fa25919128442.svg";
export { ForwardRef as ReactComponent };